<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>短信群发</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';

export default {
  name: 'messageTemplate',
  data() {
    return {};
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('messageTemplate', ['pagination'])
  },
  methods: {
    ...mapActions('messageTemplate', ['getMessageTemplates']),
    getList(data = {}) {
      this.getMessageTemplates({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
